import React from "react";
import { Card, CardContent } from "./ui/card";
import { Quote, Star } from "lucide-react";

const TestimonialSection = () => {
  const testimonials = [
    {
      name: "Marie-Claire Rousseau",
      role: "Propriétaire, Maison à Versailles",
      image: "https://images.unsplash.com/photo-1530490125459-847a6d437825",
      text: "Après l'installation de 16 panneaux photovoltaïques par UM Groupe, ma facture EDF est passée de 230€ à 45€ par mois ! En 8 mois, j'ai économisé 1 480€. L'équipe était professionnelle, l'installation terminée en 2 jours. Je recommande sans hésiter !",
      savings: "80%",
      rating: 5
    },
    {
      name: "Philippe Martin",
      role: "Retraité, Appartement 120m² à Lyon",
      image: "https://images.unsplash.com/photo-1537151913478-8b22f50bab23",
      text: "Avec ma nouvelle climatisation réversible A+++, je chauffe en hiver et rafraîchis en été pour 3 fois moins cher qu'avant. Ma facture annuelle est passée de 2 400€ à 850€. L'installation s'est faite en une journée, et le financement 0% m'a beaucoup aidé.",
      savings: "1 550€/an",
      rating: 5
    },
    {
      name: "Robert Dubois",
      role: "Entrepreneur, Villa 180m² à Bordeaux",
      image: "https://images.pexels.com/photos/34542938/pexels-photo-34542938.jpeg",
      text: "J'ai combiné panneaux solaires + climatisation réversible. Résultat après 1 an : 3 200€ d'économies ! Ma maison est autonome à 70% en électricité. L'équipe UM Groupe a géré toutes les démarches administratives. Un investissement rentabilisé en 6 ans.",
      savings: "3 200€/an",
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ils ont réduit leurs factures avec UM Groupe
          </h2>
          <p className="text-xl text-gray-600">
            Des économies réelles, des histoires authentiques
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-xl bg-white hover:shadow-2xl transition-shadow">
              <CardContent className="p-8">
                {/* Photo et infos */}
                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div className="flex-1">
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-yellow-400 fill-yellow-400" size={18} />
                  ))}
                </div>

                {/* Quote icon */}
                <Quote className="text-blue-600 mb-4" size={32} />

                {/* Testimonial text */}
                <blockquote className="text-gray-700 leading-relaxed mb-6">
                  "{testimonial.text}"
                </blockquote>

                {/* Savings badge */}
                <div className="bg-gradient-to-r from-emerald-50 to-green-50 border-2 border-emerald-500 rounded-lg p-4 text-center">
                  <p className="text-sm text-gray-600 mb-1">Économies réalisées</p>
                  <p className="text-2xl font-bold text-emerald-600">{testimonial.savings}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-blue-50 border border-blue-200 rounded-full px-6 py-3">
            <Star className="text-yellow-400 fill-yellow-400" size={20} />
            <span className="text-sm font-semibold text-gray-700">
              4.9/5 · Plus de 500 avis vérifiés
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;